import { useAuthenticator } from '@aws-amplify/ui-react';

export const REDIRECT_PARAM_NAME = 'redirectTo';

/** SessionStorage key for SSO redirect; survives OAuth round-trip since callback URL has no query. */
export const SSO_REDIRECT_STORAGE_KEY = 'ssoRedirectTo';

/** Ensures path has a leading slash so it is treated as absolute (e.g. for navigate/window.location). */
export function ensureLeadingSlash(path: string): string {
  const trimmed = path.trim();
  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
}

/**
 * Returns true if the path is safe for redirect (same-origin absolute path).
 * Rejects protocol-relative URLs (e.g. //attacker.com) and paths containing "login" to prevent open redirects.
 */
export function isSafeRedirectPath(path: string): boolean {
  const t = path.trim();
  if (t === '' || t === '/') return true;
  if (t.startsWith('//')) return false;
  // Block redirects to login page to prevent loops (case-insensitive, matches /login or /login?...)
  const pathOnly = t.split('?')[0].toLowerCase();
  if (pathOnly === '/login' || pathOnly.startsWith('/login/')) return false;
  return t.startsWith('/');
}

export function loginRedirectURL(url: URL) {
  const redirectTo = new URLSearchParams([[REDIRECT_PARAM_NAME, `${url.pathname}${url.search}`]]);
  return `/login?${redirectTo.toString()}`;
}

export enum AuthTypeEnum {
  USER_PASSWORD_AUTH = 'USER_PASSWORD_AUTH',
}

export function useAuthType() {
  const { user } = useAuthenticator();
  const type = user.signInDetails?.authFlowType;

  return type;
}
